/**
 * Consejos que rotan en el marquee de la pantalla de carga de la app
 * (ADR-2026-08-02-pantalla-carga-unificada).
 *
 * El mismo slot del marquee muestra **fotos de ejemplo** en el onboarding
 * (`carouselImages`) y **tarjetas de consejo** en la app (`tips`): en el
 * onboarding el objetivo es mostrar qué se puede lograr; adentro de la app el
 * usuario ya lo sabe, así que la espera se aprovecha para enseñarle a sacar
 * mejores resultados.
 *
 * Reglas para sumar consejos: que sean **accionables** (algo que el usuario
 * pueda hacer distinto la próxima vez) y que quepan en 2-3 líneas dentro de la
 * tarjeta de 280px. Nada de promesas de features que no existen.
 */

export interface LoadingTip {
  /** Título corto (una línea, ~30 caracteres). */
  title: string;
  /** Cuerpo del consejo (2-3 líneas dentro de la tarjeta). */
  text: string;
}

export const DEFAULT_LOADING_TIPS: LoadingTip[] = [
  {
    title: 'Cuidá la foto de origen',
    text: 'Luz pareja y fondo simple: cuanto más limpia sea la foto del producto, más nítido sale el resultado.',
  },
  {
    title: 'Probá varios formatos',
    text: 'El mismo producto puede salir como foto de catálogo, foto para redes o video. Generá varios y quedate con el mejor.',
  },
  {
    title: 'Retocá sin empezar de cero',
    text: 'Desde el editor podés cambiarle el fondo, agregarle texto o recortar cualquier resultado que ya generaste.',
  },
  {
    title: 'Conectá tu Tiendanube',
    text: 'Importá todos tus productos de una y mandá las imágenes que generes directo a tu tienda.',
  },
];
